/**
 * useInstances — OutpostForge frontend (CES standard)
 * Running instances for a scope (whole Outpost or a single asset). Used by
 * the apply confirmation to offer pick-from-list exclusions instead of
 * free-text input. Degrades to null when the lookup fails so the UI can
 * fall back gracefully.
 */

import { useEffect, useState } from 'react';
import { outpostRepository, type OutpostRepository } from '../repositories/OutpostRepository';
import type { InstanceSummary } from '../types/outposts';

export function useInstances(
  outpostId: string,
  assetId?: string,
  repository: OutpostRepository = outpostRepository,
) {
  const [instances, setInstances] = useState<InstanceSummary[] | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    repository
      .getInstances(outpostId, assetId)
      .then((result) => {
        if (!cancelled) setInstances(result);
      })
      .catch(() => {
        if (!cancelled) setInstances(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [outpostId, assetId, repository]);

  return { instances, loading };
}
